"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.seasonName = exports.monthName = exports.weekDay = exports.banglaToDigit = exports.digitToBangla = void 0;

/**
 * bengali names were taken from https://github.com/nuhil/bangla-calendar - MIT licensed
 */
var monthNames = ['বৈশাখ', 'জ্যৈষ্ঠ', 'আষাঢ়', 'শ্রাবণ', 'ভাদ্র', 'আশ্বিন', 'কার্তিক', 'অগ্রহায়ণ', 'পৌষ', 'মাঘ', 'ফাল্গুন', 'চৈত্র'];
var weekDays = ['রবিবার', 'সোমবার', 'মঙ্গলবার', 'বুধবার', 'বৃহস্পতিবার', 'শুক্রবার', 'শনিবার'];
var seasonNames = ['গ্রীষ্ম', 'বর্ষা', 'শরৎ', 'হেমন্ত', 'শীত', 'বসন্ত'];
var digits = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];
var banglas;

var createBanglas = function createBanglas() {
  banglas = digits.reduce(function (o, c, i) {
    o[c] = i;
    return o;
  }, {});
};

var digitToBangla = function digitToBangla(number) {
  return String(number).replace(/\d/g, function (digit) {
    return digits[digit];
  });
};

exports.digitToBangla = digitToBangla;

var banglaToDigit = function banglaToDigit(bangla) {
  if (!banglas) createBanglas(); // memoize

  var month = monthNames.indexOf(bangla);
  var str = month !== -1 ? month + 1 : String(bangla).replace(/./g, function (bangla) {
    var r = banglas[bangla];
    return r !== undefined ? r : bangla;
  });
  return Number(str);
};

exports.banglaToDigit = banglaToDigit;

var weekDay = function weekDay(day) {
  return weekDays[day];
};

exports.weekDay = weekDay;

var monthName = function monthName(month) {
  return monthNames[month - 1];
};

exports.monthName = monthName;

var seasonName = function seasonName(month) {
  return seasonNames[Math.floor((month - 1) / 2)];
}; // ('পৌষ' + 'মাঘ') = 'শীত'. Every consecutive two index in 'banglaMonths' indicates a single index in 'banglaSeasons'.


exports.seasonName = seasonName;